'use strict';

/**
 *  Load modules
 */
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import '../scss/app.scss';
window.addEventListener('load', function () {
  // current lang
  var currentLang = document.documentElement.lang || 'uk';

  //theme-switcher
  var switcher = document.querySelector('[data-theme-switcher]');
  var root = document.documentElement;
  if (switcher) {
    var items = switcher.querySelectorAll('.theme-switcher__item');
    var setTheme = function setTheme(theme) {
      root.setAttribute('data-theme', theme);
      localStorage.setItem('theme', theme);
      items.forEach(function (item) {
        var isActive = item.dataset.theme === theme;
        item.classList.toggle('is-active', isActive);
        var btn = item.querySelector('button');
        btn.setAttribute('aria-pressed', isActive);
      });
    };
    items.forEach(function (item) {
      item.querySelector('button').addEventListener('click', function () {
        setTheme(item.dataset.theme);
      });
    });
    var savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      setTheme(savedTheme);
    } else if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      setTheme('dark');
    } else {
      setTheme('light');
    }
  }
  document.documentElement.classList.remove('preload');
  document.body.classList.add('loaded');

  // Hide / Show Mobile Menu
  var hideShowMenuButton = document.querySelector('.hide-show-menu');
  var header = document.querySelector('.header');
  var mainContent = document.querySelector('main');
  var focusableElements = [];
  var firstFocusable = null;
  var lastFocusable = null;
  if (hideShowMenuButton && header) {
    var toggleMobileMenu = function toggleMobileMenu() {
      var isActive = document.body.classList.toggle('mobile-menu-active');

      // aria-label
      hideShowMenuButton.setAttribute('aria-label', isActive ? currentLang === 'en-US' ? 'Close mobile menu' : 'Закрити мобільне меню' : currentLang === 'en-US' ? 'Open mobile menu' : 'Відкрити мобільне меню');

      // aria-expanded
      hideShowMenuButton.setAttribute('aria-expanded', isActive);

      // hide page from screen readers
      if (mainContent) {
        if (isActive) {
          mainContent.setAttribute('aria-hidden', 'true');
        } else {
          mainContent.removeAttribute('aria-hidden');
        }
      }
      if (isActive) {
        var isVisible = function isVisible(el) {
          return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
        };
        focusableElements = Array.from(document.querySelectorAll('.hide-show-menu, \
                     .header__navigation a, \
                     .header__search button, \
                     .header__search input, \
                     .header__btns--inner a')).filter(function (el) {
          return isVisible(el) && !el.disabled;
        });
        firstFocusable = focusableElements[0];
        lastFocusable = focusableElements[focusableElements.length - 1];

        // переносимо фокус у меню
        setTimeout(function () {
          var _firstFocusable;
          (_firstFocusable = firstFocusable) === null || _firstFocusable === void 0 ? void 0 : _firstFocusable.focus();
        }, 0);
        document.addEventListener('keydown', trapFocus);
      } else {
        document.removeEventListener('keydown', trapFocus);

        // повертаємо фокус на кнопку меню
        hideShowMenuButton.focus();
      }
    };
    var trapFocus = function trapFocus(e) {
      if (!document.body.classList.contains('mobile-menu-active')) return;

      // ESC закриває меню
      if (e.key === 'Escape') {
        toggleMobileMenu();
        return;
      }
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
      } else {
        if (document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    };
    hideShowMenuButton.addEventListener('click', toggleMobileMenu);
  }

  // Scroll Reveal
  function scrollRevealCallback(el) {
    el.classList.add('is-visible');
  }

  // Ініціалізація ScrollReveal
  if (document.querySelector('.sr')) {
    var sr = ScrollReveal({
      top: 110
    });

    // Анімація елементів з класом .sr
    document.querySelectorAll('.sr').forEach(function (el) {
      sr.reveal(el, {
        duration: el.dataset.duration ? parseInt(el.dataset.duration) : 600,
        opacity: el.dataset.opacity ? parseFloat(el.dataset.opacity) : 0,
        delay: el.dataset.delay ? parseInt(el.dataset.delay) : 0,
        scale: el.dataset.scale ? parseFloat(el.dataset.scale) : 1,
        distance: el.dataset.distance || '0px',
        origin: el.dataset.origin || 'bottom',
        easing: el.dataset.easing || 'cubic-bezier(0.4, 0.2, 0.4, 1)',
        afterReveal: scrollRevealCallback
      });
    });
  }

  // оптимізоване визначення ширини скролбару
  function setScrollbarWidth() {
    requestAnimationFrame(function () {
      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
    });
  }

  // при завантаженні
  setScrollbarWidth();

  // debounce для resize
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setScrollbarWidth, 150);
  });

  //перевірка чи можуль пройдено
  document.querySelectorAll('.tutor-course-single-sidebar-wrapper .tutor-course-topic').forEach(function (topic, index) {
    var _topic$querySelector;
    var summary = topic.querySelector('.tutor-course-topic-summary');
    var title = topic.querySelector('.tutor-course-topic-title');
    if (title) {
      var moduleLabel = document.createElement('span');
      moduleLabel.className = 'title-h5';
      moduleLabel.textContent = "\u041C\u043E\u0434\u0443\u043B\u044C ".concat(index + 1);
      title.before(moduleLabel);
    }
    if (!summary) return;
    var match = summary.textContent.trim().match(/^(\d+)\/(\d+)$/);
    if (!match || match[1] !== match[2] || match[1] === '0') return;
    (_topic$querySelector = topic.querySelector('.tutor-accordion-item-header')) === null || _topic$querySelector === void 0 ? void 0 : _topic$querySelector.classList.add('tutor-accordion-item-header--passed');
    if (title) {
      var badge = document.createElement('span');
      badge.className = 'label';
      badge.textContent = 'Пройдено';
      title.before(badge);
    }
  });

  //дублікат тайтлу активного елемента
  var nav = document.querySelector('.tutor-course-spotlight-nav');
  if (!nav) return;
  var activeLessonTitle = document.querySelector('.tutor-course-topic-item.tutor-course-topic-item-lesson.is-active .tutor-course-topic-item-title');
  if (!activeLessonTitle) return;
  var titleText = activeLessonTitle.textContent.trim();
  if (!titleText) return;
  var titleEl = document.createElement('div');
  titleEl.className = 'tutor-course-lesson-title';
  titleEl.textContent = titleText;
  nav.parentNode.insertBefore(titleEl, nav);
});

// use passive listeners to improve scrolling performance
var e,
  t = ["scroll", "wheel", "touchstart", "touchmove", "touchenter", "touchend", "touchleave", "mouseout", "mouseleave", "mouseup", "mousedown", "mousemove", "mouseenter", "mousewheel", "mouseover"];
if (function () {
  var e = !1;
  try {
    var t = Object.defineProperty({}, "passive", {
      get: function get() {
        e = !0;
      }
    });
    window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
  } catch (e) {}
  return e;
}()) {
  var o = EventTarget.prototype.addEventListener;
  e = o, EventTarget.prototype.addEventListener = function (o, r, n) {
    var s,
      a = "object" == _typeof(n) && null !== n,
      i = a ? n.capture : n;
    (n = a ? function (e) {
      var t = Object.getOwnPropertyDescriptor(e, "passive");
      return t && !0 !== t.writable && void 0 === t.set ? Object.assign({}, e) : e;
    }(n) : {}).passive = void 0 !== (s = n.passive) ? s : -1 !== t.indexOf(o) && !0, n.capture = void 0 !== i && i, e.call(this, o, r, n);
  }, EventTarget.prototype.addEventListener._original = e;
}
document.addEventListener('touchstart', function () {}, {
  passive: false
});